import React from "react";
import { useFocusable } from "../../../utils/Helpers";
import { FocusableItemDirectionEnum } from "../../../utils/Focus";
export var SelectFilterItemView = function (_a) {
    var item = _a.item, index = _a.index, filter = _a.filter, selected = _a.selected, handleOnSelect = _a.handleOnSelect, onClose = _a.onClose;
    var ref = useFocusable({
        group: filter,
        index: index,
        direction: FocusableItemDirectionEnum.Vertical,
        onKeyDown: function () { return handleOnSelect(item); },
        onKeyBack: onClose,
    });
    return (React.createElement("li", { key: index + "-" + item.id, ref: ref, tabIndex: 0 },
        React.createElement("div", { className: "checkbox-box" }, selected.findIndex(function (s) { return s.id === item.id; }) > -1 ? (React.createElement("div", { className: "checkbox" })) : null),
        React.createElement("span", null, item.name)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/filter/SelectFilterItemView.tsx
// module id = 162
// module chunks = 1